import React from 'reactn';
import { useQuery, useApolloClient } from 'react-apollo-hooks';
import gql from 'graphql-tag';
import get from 'lodash/get';
import subWeeks from 'date-fns/subWeeks';
import sortBy from 'lodash/sortBy';
import { AmplifyModelContext } from 'amplify-model-react';
import { formatAWSDate } from './../common/modules';

const WEEK_RANGE = 8;

const periodRangeQuery = gql`
  query($startDate: String, $endDate: String) {
    periodByType(type: WEEK, dateFrom: { between: [$startDate, $endDate] }) {
      nextToken
      items {
        id
        name
        dateFrom
        dateTo
        type
        description
      }
    }
  }
`;

export default function useMemberPprs({
  id,
  groupByPeriod = true,
  latestOnly = true,
  fromDate,
}) {
  const errors = [];
  const [state, setState] = React.useState({ result: undefined, periods: [] });

  const { getModelSchema } = React.useContext(AmplifyModelContext);

  const pQueryVars = React.useMemo(() => {
    console.log('>>hooks/useMemberPprs::', 'formDate', fromDate); //TRACE
    const endDate = fromDate || new Date();
    const startDate = subWeeks(endDate, WEEK_RANGE);
    return { endDate, startDate };
  }, [fromDate]);

  const { data: periodData } = useQuery(periodRangeQuery, {
    variables: pQueryVars,
    fetchPolicy: 'network-only',
  });
  console.log('>>hooks/useMemberPprs::', 'periodDate', periodData); //TRACE
  const { q, validPeriodRange, periods } = React.useMemo(() => {
    const { basicFieldsString } = getModelSchema('PeriodPlanResult');
    const { basicFieldsString: periodBasicFieldsString } = getModelSchema('Period');
    const periodList = get(periodData, 'periodByType.items', []);
    if (periodList.length < 1) return { q: gql(`{__schema{directives{name}}}`) };
    const periods = sortBy(periodList, ['dateFrom']).reverse();
    const periodNextToken = get(periodData, 'periodByType.nextToken');
    const validPeriodRange = !periodNextToken;
    const qStr = `
      query ($id: ID!) {
        ${periods.map(
          (p, ii) => `
          p_${ii}:searchPeriodPlanResults(filter:{
            periodPlanResultPeriodId: {
              eq: "${p.id}"
            },
            periodPlanResultMemberId:{
              eq: $id
            }
          },limit:1,sort:{
            field:createdAt,
            direction:desc
          }){
            items{
              ${basicFieldsString}
              managerFeedback {
                commenter
                body
                date
              }
              period {
                ${periodBasicFieldsString}
              }
            }
          }
          `,
        ).join(`
        `)}        
      }
    `;
    console.log('>>hooks/useMemberPprs::', 'qStr', qStr); //TRACE
    return {
      periods,
      validPeriodRange,
      q: gql(qStr),
    };
  }, [fromDate, periodData, getModelSchema]);

  if (validPeriodRange) {
    errors.push('Invalid Date Range: either date range is to far or no periods found');
  }
  const { data, loading } = useQuery(q, {
    fetchPolicy: 'network-only',
    skip: !validPeriodRange,
    variables: {
      id,
    },
  });
  console.log('>>hooks/useMemberPprs::', 'id', state, data); //TRACE
  React.useEffect(() => {
    if (groupByPeriod && data) {
      console.log('>>hooks/useMemberPprs::', 'data', data); //TRACE
      const items = Object.entries(data);
      const result = {},
        periods = [];
      items.forEach(entry => {
        const [key, { items = [] }] = entry;
        items.forEach(item => {
          const period = item.period;
          if (!period) return;
          if (!result[period.id]) {
            result[period.id] = [];
            periods.push(period);
          }
          result[period.id].push(item);
        });
      });
      setState(oldState => ({
        ...oldState,
        result,
      }));
    }
  }, [data]);
  return { periodMap: state.result, periods, errors };
}
